"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseArrayParameterMap = parseArrayParameterMap;
exports.readArrayFormFromResolution = readArrayFormFromResolution;
exports.readArrayFormFromSubModels = readArrayFormFromSubModels;
exports.readArrayElementParametersFromSubModels = readArrayElementParametersFromSubModels;
exports.arrayParentTypeForElement = arrayParentTypeForElement;
exports.buildArrayFormSpiceModels = buildArrayFormSpiceModels;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const array_submodels_1 = require("../../../../../PackageStore/ComponentArrays/array-submodels");
function parseArrayParameterMap(parameters, parameterDefs) {
    const unitsByName = new Map(parameterDefs.map((def) => [def.name, def.units ?? {}]));
    const parameterMap = {};
    for (const [name, entry] of Object.entries(parameters)) {
        const raw = entry?.value?.trim() ?? '';
        if (raw === '') {
            continue;
        }
        try {
            const parsed = sigma_engine_shared_1.Utils.parseNumericalSIValue(raw, unitsByName.get(name) ?? {});
            if (!Number.isNaN(parsed)) {
                parameterMap[name] = parsed;
            }
        }
        catch {
        }
    }
    return parameterMap;
}
function readArrayFormFromResolution(resolution) {
    if (!(0, array_submodels_1.isArrayParentSigmaModel)(resolution.sigmaModelId)) {
        return null;
    }
    if (resolution.spiceModels === undefined) {
        return null;
    }
    const submodels = resolution.spiceModels.filter(sigma_engine_shared_1.DesignModels.SPICE.isSubModelSigmaSubModel);
    if (submodels.length === 0) {
        return null;
    }
    const prefixResult = (0, array_submodels_1.extractArraySubmodelPrefix)(submodels.map((submodel) => submodel.subModelId));
    if (!prefixResult.isValid || prefixResult.prefix === undefined) {
        return null;
    }
    const elementModelIds = new Set(submodels.map((submodel) => submodel.modelId));
    if (elementModelIds.size !== 1) {
        return null;
    }
    const [elementModelType] = [...elementModelIds];
    if (elementModelType === undefined) {
        return null;
    }
    const config = (0, array_submodels_1.getArrayElementConfig)(elementModelType);
    if (config === null || config.parentType !== resolution.sigmaModelId) {
        return null;
    }
    return {
        confirmed: true,
        elementModelType,
        elementCount: submodels.length,
        submodelPrefix: prefixResult.prefix,
    };
}
function readArrayFormFromSubModels(spiceModels) {
    const submodel = spiceModels?.find(sigma_engine_shared_1.DesignModels.SPICE.isSubModelSigmaSubModel);
    if (submodel === undefined) {
        return null;
    }
    const config = (0, array_submodels_1.getArrayElementConfig)(submodel.modelId);
    if (config === null) {
        return null;
    }
    return readArrayFormFromResolution({ sigmaModelId: config.parentType, spiceModels });
}
function readArrayElementParametersFromSubModels(spiceModels) {
    const [submodel] = (spiceModels ?? [])
        .filter(sigma_engine_shared_1.DesignModels.SPICE.isSubModelSigmaSubModel)
        .sort((left, right) => left.subModelId.localeCompare(right.subModelId));
    if (submodel === undefined) {
        return {};
    }
    const parameters = {};
    for (const [key, value] of Object.entries(submodel.modelInfo.parameterMap ?? {})) {
        parameters[key] = { value: String(value), variance: null };
    }
    return parameters;
}
function arrayParentTypeForElement(elementModelType) {
    return (0, array_submodels_1.getArrayElementConfig)(elementModelType)?.parentType ?? null;
}
function buildArrayFormSpiceModels(args) {
    if (!args.arrayForm.confirmed) {
        return [];
    }
    return (0, array_submodels_1.buildArraySubModels)({
        elementModelId: args.arrayForm.elementModelType,
        elementCount: args.arrayForm.elementCount,
        submodelPrefix: args.arrayForm.submodelPrefix,
        signals: args.signals.map((signal) => ({ id: signal.id, name: signal.name })),
        elementModelSignals: args.elementSignals,
        parameterMap: parseArrayParameterMap(args.parameters, args.parameterDefs),
    });
}
//# sourceMappingURL=array-resolution-adapter.js.map